import { render, staticRenderFns } from "./StepB.vue?vue&type=template&id=51f7cec9&scoped=true"
import script from "./StepB.vue?vue&type=script&lang=js"
export * from "./StepB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7cec9",
  null
  
)

export default component.exports